import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ActivistBadgeComponent } from './activist-badge/activist-badge.component';
import { BaseBadgeComponent } from './base-badge/base-badge.component';
import { ChangeBadgeComponent } from './change-badge/change-badge.component';
import { SimpleChangeBadgeComponent } from './simple-change-badge/simple-change-badge.component';
import { TrendBadgeComponent } from './trend-badge/trend-badge.component';

const components = [ActivistBadgeComponent, ChangeBadgeComponent, SimpleChangeBadgeComponent, TrendBadgeComponent];

@NgModule({
  imports: [CommonModule],
  declarations: [BaseBadgeComponent, ...components],
  exports: [...components]
})
export class CommonBadgesModule {}
